import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { indexOf, reduce } from 'lodash';
import {
  Modal, Button, FormGroup,
  ControlLabel, FormControl,
} from 'react-bootstrap';
import LocaleCode from 'locale-code';
import { updateSenderLanguage } from '../../../Dashboard/DashboardActions';
import { transalteLanguageCode } from '../../../../util/helpers';

class EditLanguageModal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedLanguage: null,
      errors: null,
      submitting: false,
    };
    this.close = this.close.bind(this);
    this.onExited = this.onExited.bind(this);
    this.selectLanguage = this.selectLanguage.bind(this);
    this.submit = this.submit.bind(this);
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.survey) {
      if (!this.props.survey || this.props.survey.id !== nextProps.survey.id) {
        const { selectedLanguage } = nextProps;
        this.setState({
          open: true,
          survey: nextProps.survey,
          selectedLanguage,
        });
      }
    } else {
      this.setState({ open: false });
    }
  }

  onExited() {
    this.setState({ survey: null, success: false }, () => {
      this.props.onClose();
    });
  }

  close() {
    this.setState({
      submitting: false,
      open: false,
      selectedLanguage: null,
      errors: null,
    });
  }

  selectLanguage(e) {
    const selectedLanguage = e.target.value;
    this.setState({ selectedLanguage });
    this.props.onLanguageChange(selectedLanguage);
  }

  submit() {
    const { survey, isAccount } = this.props;
    const { selectedLanguage } = this.state;
    this.setState({ submitting: true });
    this.props.dispatch(updateSenderLanguage(survey.collector_id, survey.object_id, survey.id, selectedLanguage, isAccount))
      .then(
        () => {
          this.setState({ submitting: false, success: true });
          this.props.onSuccess({ ...survey, language: selectedLanguage });
        },
        (errors) => {
          this.setState({ submitting: false, success: false, errors });
        },
      );
  }

  renderError() {
    const { errors } = this.state;
    let messgage = 'Internal Server Error';
    if (errors && errors.statusText) {
      messgage = errors.statusText;
    }
    return (
      <div className="animated flash alert alert-danger">
        {messgage}
      </div>
    );
  }

  renderForm() {
    const {
      disabled,
      availableLanguages,
    } = this.props;
    const { selectedLanguage, submitting } = this.state;
    const allLanguages = reduce(availableLanguages, (items, i) => {
      items.push({
        value: i,
        label: LocaleCode.getLanguageNativeName(i),
        disabled: false,
      });
      return items;
    }, []);

    const exists = indexOf(availableLanguages, selectedLanguage) >= 0;
    if (!exists) {
      allLanguages.push({
        value: selectedLanguage,
        label: LocaleCode.getLanguageNativeName(selectedLanguage),
        disabled: true,
      });
    }
    return (
      <div>
        <FormGroup>
          <ControlLabel>Language</ControlLabel>
          <FormControl
            value={selectedLanguage}
            componentClass="select"
            disabled={(disabled || submitting)}
            onChange={this.selectLanguage}
          >
            {allLanguages.map(o => (
              <option key={o.value} value={o.value} disabled={o.disabled}>
                {o.label}
              </option>
            ))}
          </FormControl>
        </FormGroup>
      </div>
    );
  }

  render() {
    const {
      open, survey, submitting, success,
      errors, selectedLanguage,
    } = this.state;
    const { isAccount } = this.props;
    const hasSurvey = survey && survey.id;
    const props = {};
    if (hasSurvey) {
      if (isAccount) {
        props.account_id = survey.object_id;
      } else {
        props.opportunity_id = survey.object_id;
      }
    }
    const hasErrors = errors !== null;
    return (
      <Modal
        show={open}
        onHide={this.close}
        onExited={this.onExited}
      >
        {hasSurvey &&
          <Modal.Header closeButton>
            <Modal.Title>Change Language for {survey.first_name} {survey.last_name} {selectedLanguage}</Modal.Title>
          </Modal.Header>
        }
        {open && hasSurvey &&
          <Modal.Body>
            <div>
              {!success && !hasErrors && this.renderForm()}
              {success &&
                <div className="animated flash alert alert-success">
                  {selectedLanguage === null && <span>Survey Language updated!</span>}
                  {selectedLanguage !== null && <span>Survey language was changed to {LocaleCode.getLanguageName(selectedLanguage)}!</span>}
                </div>
              }
              {!success && hasErrors && this.renderError()}
            </div>
          </Modal.Body>
        }
        <Modal.Footer>
          {!success && !hasErrors &&
            <div className="clearfix">
              <Button bsStyle="link" className="pull-left" onClick={this.close}>Done</Button>
              <Button
                bsStyle="primary"
                disabled={(submitting || (hasSurvey && selectedLanguage === transalteLanguageCode(survey.language)))}
                onClick={this.submit}
              >
                Save
              </Button>
            </div>
          }
          {(success || hasErrors) && <Button bsStyle="link" onClick={this.close}>Done</Button>}
        </Modal.Footer>
      </Modal>
    );
  }
}

EditLanguageModal.propTypes = {
  dispatch: PropTypes.func.isRequired,
  selectedLanguage: PropTypes.string,
  survey: PropTypes.shape({
    id: PropTypes.string,
    contact_id: PropTypes.string,
    first_name: PropTypes.string,
    last_name: PropTypes.string,
    collector_id: PropTypes.string,
    time_zone: PropTypes.shape({}),
    object_id: PropTypes.string,
    client_id: PropTypes.string,
    program_id: PropTypes.string,
    is_sales_rep_first: PropTypes.bool,
    collector_email: PropTypes.string,
    email_from: PropTypes.shape({
      email: PropTypes.string,
    }),
  }),
  onClose: PropTypes.func,
  isAccount: PropTypes.bool,
  onSuccess: PropTypes.func,
  disabled: PropTypes.bool,
  onLanguageChange: PropTypes.func,
  availableLanguages: PropTypes.arrayOf(PropTypes.string),
};
EditLanguageModal.defaultProps = {
  survey: null,
  isAccount: false,
  selectedLanguage: null,
  availableLanguages: [],
  disabled: false,
  onClose: () => {},
  onSuccess: () => {},
  onLanguageChange: () => {},
};
EditLanguageModal.contextTypes = {
};

function mapStateToProps() {
  return {};
}

export default connect(mapStateToProps)(EditLanguageModal);
